import { SystemStatus } from "../systemEdit/SystemEdit.types";
import { SystemDataType, SystemEntityType, SystemStorageType } from "../systemEdit/SystemEdit.types";

export interface SystemOverviewInfoViewModel {
    id: string;
    name: string;
    description: string;
    numberOfDocuments: number;
    numberOfSuppliers: number;
    numberOfUsersWithAccess: number;
    numberOfProcessingActivities: number;
    numberOfAudits: number;
    numberOfClassifications: number;
    userFriendlyId: number;
    entityTemplateId: string;
    templateSteps: Array<SystemTemplateStepInfo>;
}

export interface SystemTemplateStepInfo {
    id: string;
    name: string;
    order: number;
}

export interface SecurityMeasureOverviewModel {
    name: string;
    isMet: boolean;
}

export interface DataLocationViewModel {
    storageLocationCountryCodes: Array<string>;
    supportLocationCountryCodes: Array<string>;
}

export interface BaseViewModel {
    name: string;
    id: string;
}

export interface DataProcessorViewModel {
    name: string;
    id: string;
    link: string;
    isThirdCountry: boolean;
    countryCode: string;
    transferBasis: string;
    isGroupEntity: boolean;
}

export enum SystemOverviewPaperTabEnum {
    Main = 0,
    AllSystemInfo = 1,
}

export enum SystemPlanTabId {
    Documents = "documents",
    Suppliers = "suppliers",
    Access = "access",
    ProcessingActivities = "processingActivities",
    Audits = "audits",
    Classifications = "classifications",
    Tasks = "tasks",
}

export interface SystemIsmsInfoViewModel {
    status: SystemStatus | null;
    storageType: SystemStorageType | null;
    dataTypes: Array<SystemDataType> | null;
    entityType: SystemEntityType | null;
    isCriticalForOperation: boolean | null;
    systemCertifications: Array<string> | null;
}
